import React from "react";
import Cookies from "js-cookie";
import { Button, Grid } from "@material-ui/core";
import { SetCookieClient } from "../../api";
import { discoveryApiRef, fetchApiRef, useApi } from "@backstage/core-plugin-api";

export const SetCookieComponent = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);

  const handleAuth = async () => {
    const client = new SetCookieClient({ discoveryApi, fetchApi });
    try {
      const response = await client.getCookie();
      setCookie(response.access_token); // Assuming API returns { access_token: "your_token" }
      alert("Authorization Successfull. Please go ahead and use the api's!")
    } catch (error) {
      alert(`Failed to set cookie: ${error}`)
      console.error("Failed to Authorize:", error);
    }
  };

  const setCookie = (token: string) => {
    Cookies.set("authToken", token, { expires: 7, path: "/" });
  };

  const handleLogOut = async () => {
    Cookies.remove("authToken")
    alert('Logged Out Successfully')
  };


  return (
    <Grid container spacing={1} alignItems="flex-end" direction="row">
      <Grid item md={1}>
        <Button variant="contained" color="primary" onClick={handleAuth}>Authorize</Button>
      </Grid>
      <Grid item md={1}>
        <Button variant="contained" color="secondary" onClick={handleLogOut}>LogOut</Button>
      </Grid>
    </Grid>
  )
};